import React, { useState, useRef, useEffect } from "react";
import styles from "./Select.module.scss";
import Arrow from "../../../assets/images/svgs/Arrow";

interface Option {
  id: string;
  name: string;
}

interface SelectProps {
  label?: string;
  error?: string;
  options: Option[];
  value: string;
  onChange: (value: { id: string; name: string }) => void;
  className?: string;
  loaderRef?: React.RefObject<HTMLDivElement | null>;
}

const Select: React.FC<SelectProps> = ({
  label,
  error,
  options,
  value,
  onChange,
  className = "",
  loaderRef,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const selectedOption =
    options.find((opt) => opt.id === value) ||
    options.find((opt) => opt.name === value);

  return (
    <div className={`${styles.selectWrapper} ${className}`} ref={wrapperRef}>
      {label && <label className={styles.label}>{label}</label>}
      <div
        className={`${styles.customSelect} ${error ? styles.selectError : ""} ${
          open ? styles.selectActive : ""
        }`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span>{selectedOption?.name || "Select..."}</span>
        <Arrow className={open ? styles.arrowUp : styles.arrowDown} />
      </div>
      {open && (
        <div className={styles.optionsDropdown}>
          {options.map((opt) => (
            <div
              key={opt.id}
              className={`${styles.option} ${
                value === opt.id || value === opt.name ? styles.active : ""
              }`}
              onClick={() => {
                onChange({ id: opt.id, name: opt.name }); // <-- id + name birlikdə
                setOpen(false);
              }}
            >
              {opt.name}
            </div>
          ))}
          {loaderRef && (
            <div ref={loaderRef} className={styles.loaderTrigger} />
          )}
        </div>
      )}
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default Select;
